import du from '../utils/dom-utilities';

export default function careerFormOption () {
        var  el = document.querySelector('.js-input-file-tab');
        if (el != null) {
            var inputFile = document.querySelector('.js-form-career-input-file').cloneNode(true);

            selectDisplayOtherInput();
            displayInputFileName(el);
            addNewInputFile(el, inputFile);

        }
};

function selectDisplayOtherInput() {
    du.queryAll('.js-career-form-selectOther').forEach((item) => {
        du.onEvent(item, 'change', function() {
            if (item.querySelector('.js-career-form-select').value === 'other'){
                item.querySelector('.js-career-form-other').classList.remove('form-hidden');
            } else {
                item.querySelector('.js-career-form-other').classList.add('form-hidden');
            }
        });
    });
}

function displayInputFileName(el) {
    du.onEvent(el, 'change', function() {
        du.queryAll('.js-form-input-file', el).forEach((item) => {
            var docName = item.querySelector('.js-uploadBtn').value.replace('C:\\fakepath\\', '');
            item.querySelector('.js-uploadFileName').value = docName;
        });
    });
}

function addNewInputFile(el, inputFile) {
    du.onEvent(el, 'change', function() {
        if (du.queryAll('.js-uploadFileName', el).every(hasAValue)) {
            var newInput = inputFile.cloneNode(true);
            el.appendChild(newInput);
            removeInputFile(newInput);
        }
    });
}

function removeInputFile(item) {
    du.onEvent(item.querySelector('.js-input-file-erase'), 'click', function() {
        if  (item.querySelector('.js-uploadBtn').value.length) {
            item.parentNode.removeChild(item);
        }
    });
}

function hasAValue(element) {
    return (element.value.length > 0);
}



// WEBPACK FOOTER //
// ./src/main/js/components/careerForm.js